import { createContext } from 'react'

export type ToastTone = 'success' | 'error'

export interface ToastOptions {
  title: string
  description?: string
  tone?: ToastTone
}

export interface ToastContextValue {
  showToast: (options: ToastOptions) => void
}

export const ToastContext = createContext<ToastContextValue | null>(null)
